module.exports = __webpack_public_path__ + "img/10-anos.4585c197.jpg";